const Resume_Api = [
    {
        id: 1,
        category: "wrkexp",
        year: "Aug 2023 - Sep 2023",
        company: "Skyfield Agritech, UAE",
        title: "Amazon Associate Freelancer (E-commerce)",
        desc: "Created product listings on Amazon, which involved providing detailed and accurate product information. Optimized product titles, descriptions, and images to enhance visibility and appeal to potential customers. Ensured that all product listings comply with Amazon's guidelines and policies. Implemented SEO strategies to boost a product's position at 1st position in the Amazon search results. ",
      },  
    {
      id: 2,
      category: "experience",
      year: "May 2022 - Nov 2022",
      company: "Sudivguide, Goa",
      title: "Web Developer and Digital Marketing Specialist",
      desc: "SUDIVEGUIDE is a portal where we provide essays, GK questions, words for kids, maths, and rhymes for Class 1, 2 & 3 Students. We have come up with a unique way of writing for students that will be easier for them to understand and grasp.      ",
    },
    {
        id: 3,
        category: "experience",
        year: "March 2022 - Oct 2022",
        company: "CPI Mallikarjun School, Goa",
        title: "Website Developer and SMO",
        desc: "Created the UI design for the CPI Mallikarjun School website, focusing on creating an engaging and user-friendly interface for the school's online presence. Used best SEO techniques to increase visibility in search results.Developed and managed social media content for the CPImallikarjun website.",
      },
   
  ]
  
  export default Resume_Api
  